import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { WorkflowDTOType } from '../../../schemas/index';
import { useAppDispatch } from '../../../store/store';
import { setWorkflowFilters } from '../../../store/workflows/slice';

interface IUseSyncWithUrlProps {
  openProductsDrawer: (workflow: WorkflowDTOType) => void;
  workflows: Array<WorkflowDTOType>;
}

const useSyncWithUrl = ({ openProductsDrawer, workflows }: IUseSyncWithUrlProps) => {
  const location = useLocation();

  const dispatch = useAppDispatch();

  const params = new URLSearchParams(location.search);
  const productsDrawerId = params.get('productsDrawer');

  const workflow = workflows.find(w => String(w.id) === productsDrawerId);

  useEffect(() => {
    if (!productsDrawerId) {
      return;
    }

    if (!workflow) {
      dispatch(
        setWorkflowFilters([
          {
            field: 'id',
            filterType: 'EQ',
            value: productsDrawerId,
          },
        ]),
      );
    }

    if (workflow) {
      openProductsDrawer(workflow);
    }
  }, [productsDrawerId, workflow]);
};

export default useSyncWithUrl;
